document.querySelectorAll(".media").forEach((e) => {
  // check if previous sibling exists, which means we have a splash image
  if (e.previousElementSibling) {
    // upscale splash on mouse hover
    e.addEventListener("mouseover", (e) => {
      root.style.setProperty("--scale-min", 0);
      let parent = e.target.parentNode;
      let splash = parent.previousElementSibling;
      if (splash) {
        splash.classList.add("show");
      }
    });

    // downscale splash on mouseleave
    e.addEventListener("mouseleave", (e) => {
      let parent = e.target.parentNode;
      let splash = parent.querySelector(".item-full_splash");
      if (splash) {
        splash.classList.remove("show");
      }
    });
  }
});

document.querySelectorAll("#product-grid .grid__item").forEach((e) => {
  // check if previous sibling exists, which means we have a splash image
  let splash = e.querySelector(".item-full_splash");
  let img = e.querySelector(".media img+img");
  if (splash) {
    // upscale splash on mouse hover
    e.addEventListener("mouseover", (e) => {
      img.style.transform = "scale(1.03)";
      splash.classList.add("show");
    });

    // downscale splash on mouseleave
    e.addEventListener("mouseleave", (e) => {
      img.style.transform = "scale(1)";
      splash.classList.remove("show");
    });
  }
});
